import React, { useMemo } from 'react';
import SearchableSelect from './SearchableSelect';
import { useActiveUsers } from '../utils/useActiveUsers';

/**
 * ユーザー選択特化型コンポーネント (UserSelect) - Smart Component
 *
 * 汎用UIのSearchableSelectをラップし、有効ユーザーデータの取得と options 整形、
 * ドメイン固有のプレースホルダーをカプセル化する。親は value と onChange のみ渡せばよい。
 */
function UserSelect({ value, onChange, disabled, id, placeholder }) {
    const { users, loading } = useActiveUsers();
    const options = useMemo(
        () => users.map(u => ({ value: u.id, label: u.user_name })),
        [users]
    );

    return (
        <SearchableSelect
            id={id}
            options={options}
            value={value}
            onChange={onChange}
            disabled={disabled || loading}
            placeholder={loading ? '読み込み中...' : (placeholder || '担当者を選択...')}
            noResultsText="該当するユーザーがいません"
            searchPlaceholder="ユーザー名で検索..."
        />
    );
}

export default UserSelect;
